import { Routes, Route, Link, useLocation, useNavigate } from 'react-router'
import DeviceList from './pages/DeviceList'
import DeviceDetail from './pages/DeviceDetail'
import Login from './pages/Login'
import AcceptInvite from './pages/AcceptInvite'
import Organizations from './pages/Organizations'
import Users from './pages/Users'
import Platforms from './pages/Platforms'
import AuditLog from './pages/AuditLog'
import Account from './pages/Account'
import EnrollmentCodes from './pages/EnrollmentCodes'
import RequireAuth from './auth/RequireAuth'
import { useAuth } from './auth/AuthContext'

const navStyle: React.CSSProperties = {
  background: '#1a1a2e',
  color: '#fff',
  padding: '0 24px',
  display: 'flex',
  alignItems: 'center',
  height: 56,
  gap: 24,
}

const linkStyle: React.CSSProperties = {
  color: '#ccc',
  textDecoration: 'none',
  fontSize: 14,
  fontWeight: 500,
}

const mainStyle: React.CSSProperties = {
  maxWidth: 1200,
  margin: '0 auto',
  padding: '24px 16px',
}

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation()
  const active = location.pathname === to || (to !== '/' && location.pathname.startsWith(to))
  return (
    <Link to={to} style={{ ...linkStyle, color: active ? '#fff' : '#ccc' }}>
      {children}
    </Link>
  )
}

function AppNav() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // No nav chrome on the public login/accept-invite screens.
  if (location.pathname === '/login' || location.pathname === '/accept-invite') {
    return null
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <nav style={navStyle}>
      <span style={{ fontWeight: 700, fontSize: 18, color: '#fff', marginRight: 16 }}>SIP Failover</span>
      <NavLink to="/">Devices</NavLink>
      {user && (user.IsSuperUser || user.CanManageUsers) && <NavLink to="/organizations">Organizations</NavLink>}
      {user && (user.IsSuperUser || user.CanManageUsers) && <NavLink to="/users">Users</NavLink>}
      {user && (user.IsSuperUser || user.CanManagePlatforms) && <NavLink to="/platforms">Platforms</NavLink>}
      {user && (user.IsSuperUser || user.CanManageDevices) && <NavLink to="/enrollment-codes">Enrollment Codes</NavLink>}
      {user && (user.IsSuperUser || user.CanManageUsers) && <NavLink to="/audit-log">Audit Log</NavLink>}
      <span style={{ flex: 1 }} />
      {user && (
        <>
          <Link to="/account" style={{ color: '#9ca3af', fontSize: 13, textDecoration: 'none' }}>{user.Email}</Link>
          <button
            onClick={handleLogout}
            style={{ background: 'none', border: '1px solid #444', color: '#ccc', borderRadius: 6, padding: '5px 12px', cursor: 'pointer', fontSize: 13 }}
          >
            Sign out
          </button>
        </>
      )}
    </nav>
  )
}

export default function App() {
  return (
    <div>
      <AppNav />
      <main style={mainStyle}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/" element={<RequireAuth><DeviceList /></RequireAuth>} />
          <Route path="/devices/:id" element={<RequireAuth><DeviceDetail /></RequireAuth>} />
          <Route path="/organizations" element={<RequireAuth><Organizations /></RequireAuth>} />
          <Route path="/users" element={<RequireAuth><Users /></RequireAuth>} />
          <Route path="/platforms" element={<RequireAuth><Platforms /></RequireAuth>} />
          <Route path="/audit-log" element={<RequireAuth><AuditLog /></RequireAuth>} />
          <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
          <Route path="/enrollment-codes" element={<RequireAuth><EnrollmentCodes /></RequireAuth>} />
        </Routes>
      </main>
    </div>
  )
}
